module.exports = __webpack_public_path__ + "img/background_blue.45fc6bae.jpg";